module.exports = __webpack_public_path__ + "static/media/redCross.38828d9a.svg";